import { render, staticRenderFns } from "./GeneralForm.vue?vue&type=template&id=0836e044&scoped=true&"
import script from "./GeneralForm.vue?vue&type=script&lang=js&"
export * from "./GeneralForm.vue?vue&type=script&lang=js&"
import style0 from "./GeneralForm.vue?vue&type=style&index=0&id=0836e044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0836e044",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
